import React from 'react';
import { Toaster } from 'sonner';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosSection } from './components/BonosSection';
import { ComparisonTable } from './components/ComparisonTable';
import { UrgencyModule } from './components/UrgencyModule';
import { Pricing } from './components/Pricing';
import { EditionCompleta } from './components/EditionCompleta';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyMobileCta } from './components/StickyMobileCta';
import { SocialProofToast } from './components/SocialProofToast';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-slate-800 selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <Toaster position="top-center" data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <header data-id="element-3">
        <AnnouncementBar data-id="element-4" />
      </header>

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <Testimonials data-id="element-7" />
        <PainPoints data-id="element-8" />
        <TargetAudience data-id="element-9" />
        <SystemOverview data-id="element-10" />
        <TomosAccordion data-id="element-11" />
        <BonosSection data-id="element-12" />
        <ComparisonTable data-id="element-13" />
        <UrgencyModule data-id="element-14" />
        <Pricing id="pricing" data-id="element-15" />
        <EditionCompleta data-id="element-16" />
        <Guarantee data-id="element-17" />
        <Faq data-id="element-18" />
        <FinalCta data-id="element-19" />
      </main>

      <Footer data-id="element-20" />
      <StickyMobileCta data-id="element-21" />
      <SocialProofToast data-id="element-22" />
    </div>;
}